@switch (asset.category) { @case (categoryImage) {
<div class="asset-container">
  @if (!!url) {
  <img
    (load)="loaded()"
    (error)="error()"
    #image
    [class.loaded]="isLoaded"
    [src]="url"
  />
  } @if (isLoading) {
  <av-spinner class="loader" size="xs"></av-spinner>
  }
</div>
} @case (categoryDocument) {
<div class="pill">{{ asset.filename || asset.id }}</div>
} } @if (isLoaded) {
<button
  class="remove"
  avButton
  [raised]="true"
  size="xxs"
  ofType="icon"
  [loading]="isLoading"
  (click)="remove()"
  data-tid="asset/remove"
>
  <av-icon name="trash"></av-icon>
</button>
}

<ng-content></ng-content>
